import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const DashboardContent = ({ title, content, icon = 'Info' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="space-y-6"
    >
      {/* Header */}
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-primary-50 rounded-lg flex items-center justify-center">
          <Icon name={icon} size={20} color="#8B1538" />
        </div>
        <div>
          <h1 className="text-2xl lg:text-3xl font-bold text-text-primary">{title}</h1>
          <p className="text-text-muted mt-1">Coming soon</p>
        </div>
      </div>

      {/* Content */}
      <div className="bg-surface rounded-xl p-8 border border-border text-center">
        <div className="w-16 h-16 bg-primary-50 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Clock" size={32} color="#8B1538" />
        </div>
        <h2 className="text-xl font-semibold text-text-primary mb-2">Feature Coming Soon</h2>
        <p className="text-text-muted mb-6 max-w-md mx-auto">
          {content}
        </p>
        <div className="bg-surface-100 rounded-lg p-4 text-sm text-text-muted">
          This feature is being developed and will be available in a future update. 
          Thank you for your patience!
        </div>
      </div>
    </motion.div>
  );
};

export default DashboardContent;